var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFivePointedStar = function SvgFivePointedStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.527,
    height: 17.692,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7A7A7A",
    fillRule: "evenodd",
    d: "m18.316 7.424-4.019 3.918.95 5.532a.699.699 0 0 1-1.016.738L9.264 15l-4.968 2.612a.7.7 0 0 1-1.015-.738l.95-5.532L.21 7.424A.701.701 0 0 1 .6 6.23l5.554-.807L8.636.389a.703.703 0 0 1 1.255 0l2.483 5.034 5.554.807c.383.057.65.411.59.794a.7.7 0 0 1-.203.4M11.71 6.337l5.473.795-3.96 3.861.935 5.45-4.894-2.573-4.895 2.573.936-5.45-3.96-3.86 5.472-.796 2.447-4.96z"
  })));
};
export default SvgFivePointedStar;